import { createEvent } from 'utils/DomUtils';
import { CLOSE_EVENT_PREFIX } from './PortalSlider';

export async function closePortalSlider(id: string) {
  window.dispatchEvent(createEvent(`${CLOSE_EVENT_PREFIX}${id}`));
}
